import { keysWithMap, nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var Profile = t.type({
  id: t.string,
  username: t.string,
  name: t.string,
  email: t.string,
  title: nullable(t.string),
  company: nullable(t.string),
  avatarUrl: nullable(t.string)
});
export var WelcomeMessageOnboarding = t.type({
  message: t.string
});
export var OnboardingStatus = keysWithMap({
  SKIPPED: 'SKIPPED',
  PASSED: 'PASSED',
  NOT_PASSED: 'NOT_PASSED'
});
export var ChallengeOnboarding = t.type({
  challengeID: t.string,
  skippable: t["boolean"]
});